<div class="row animate__animated animate__fadeIn" *ngIf="!loading">

    <div class="col-12 pageParent">

        <!-- Primer Swiper -->
        <div class="row  animate__animated animate__fadeIn animate__delay-1s">
            <div class="col-12 mt-5 mt-lg-5 px-0 " *ngIf="firstSlideShow?.length > 0">
                <h2 class="text-white font_CinematecaBlack fs-4 ml-3 mb--30">{{firstSlideShowTitle}}</h2>
                <br>
                <br>
                <!-- <div class="line"></div> -->
                <div class="swiper-parent">
                    <app-ui-slides-carousel [movies]="firstSlideShow" [swiperConfig]="firstSlideShowConfig"
                        [noBorders]="true" [showInfo]="true">
                    </app-ui-slides-carousel>
                </div>
            </div>
        </div>
        <!-- ------ -->

        <!-- Reviews populares -->
        <br>
        <br>
        <br>
        <div class="row animate__animated animate__fadeIn animate__delay-2s" *ngIf="commentList1.length > 0">
            <h2 class="text-white font_CinematecaBlack fs-4 ml-3 mb--30" style="text-align: left;">
                {{popularReviewsTitle}}</h2>
            <br>
            <br>
            <div class="row">
                <div class="col-lg-6 ">
                    <div class="listaComentariosContenedor">
                        <ul class="list-group listaComentarios">
                            <li *ngFor="let comments of commentList1">
                                <app-dark-comment-item [comment]="comments" [withAuthor]="true">
                                </app-dark-comment-item>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 ">
                    <div class="listaComentariosContenedor" *ngIf="commentList2.length > 0">
                        <ul class="list-group listaComentarios">
                            <li *ngFor="let comments of commentList2">
                                <app-dark-comment-item [comment]="comments" [withAuthor]="true">
                                </app-dark-comment-item>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- ------ -->

        <!-- Primer Card Swiper -->
        <br>
        <br>
        <div class="row animate__animated animate__fadeIn animate__delay-3s">
            <div class="col-12 mt-5 mt-lg-5 px-0 " *ngIf="firstCardShow?.length > 0">
                <h2 class="text-white font_CinematecaBlack fs-4 ml-3 mb--30">{{firstCardShowTitle}}</h2>
                <br>
                <br>
                <!-- <div class="line"></div> -->
                <div class="swiper-parent">
                    <app-ui-slides-card-carousel [movies]="firstCardShow" [swiperConfig]="firstCardShowConfig"
                        [noBorders]="true">
                    </app-ui-slides-card-carousel>
                </div>
            </div>
        </div>
        <!-- ------ -->

        <!-- Segundo Card Swiper -->
        <div class="row animate__animated animate__fadeIn animate__delay-4s">
            <div class="col-12 mt-3 mt-lg-3 px-0 " *ngIf="secondCardShow?.length > 0">
                <h2 class="text-white font_CinematecaBlack fs-4 ml-3 mb--30">{{secondCardShowTitle}}</h2>
                <br>
                <br>
                <!-- <div class="line"></div> -->
                <div class="swiper-parent">
                    <app-ui-slides-card-carousel [movies]="secondCardShow" [swiperConfig]="secondCardShowConfig"
                        [noBorders]="true">
                    </app-ui-slides-card-carousel>
                </div>
            </div>
        </div>
        <!-- ------ -->

        <!-- Review de criticos -->
        <br>
        <br>
        <br>
        <div class="row animate__animated animate__fadeIn animate__delay-4s mb-5">
            <div class="col-12 mt-3 mt-lg-3 px-0" *ngIf="criticReview1">
                <h2 class="text-white font_CinematecaBlack fs-4 ml-3 mb--30">{{criticReviewsTitle}}</h2>
                <br>
                <br>
                <!-- <div class="line"></div> -->
                <app-critic-review [comment]="criticReview1" [withAuthor]="true" [withRating]="true"
                    *ngIf="criticReview1">
                </app-critic-review>
                <app-critic-review [comment]="criticReview2" [withAuthor]="true" [withRating]="true"
                    *ngIf="criticReview2">
                </app-critic-review>
            </div>

            <div class="col-12 pr-5 text-right">
                <button class="py-2 mb-3 btnVerTodos btn cm-bg-color-11 text-white" routerLink="reviews">
                    Ver todas las críticas
                </button>
            </div>
        </div>
        <!-- ------ -->

        <!-- Listas de miembros -->
        <!-- <br>
        <br>
        <div class="row animate__animated animate__fadeIn animate__delay-4s">
            <div class="col-12 mt-3 mt-lg-3 px-0" *ngIf="">
                <h2 class="text-white font_CinematecaBlack fs-4 ml-3 mb--30">{{criticReviewsTitle}}</h2>
                <br>
                <br>
                <div class="line"></div>

            </div>
        </div> -->
        <!-- ------ -->

    </div>

</div>